const affiliations = [
    { value: 'AAA', label: 'AAA' },
    { value: 'American Express', label: 'American Express' },
    { value: 'CAA', label: 'CAA' },
    { value: 'Carlson Wagonlit Travel', label: 'Carlson Wagonlit Travel' },
    { value: 'Ensemble Travel', label: 'Ensemble Travel' },
    { value: 'Global Services', label: 'Global Services' },
    { value: 'Leisure Travel Alliance', label: 'Leisure Travel Alliance' },
    { value: 'Liberty Travel', label: 'Liberty Travel' },
    { value: 'MAST', label: 'MAST' },
    { value: 'Signature', label: 'Signature' },
    { value: 'Travel Edge', label: 'Travel Edge' },
    { value: 'Travel Leaders Network', label: 'Travel Leaders Network' },
    { value: 'Traveler Made', label: 'Traveler Made' },
    { value: 'Travelsavers/Nest/Affluent Traveler Collection', label: 'Travelsavers/Nest/Affluent Traveler Collection' },
    { value: 'Uniglobe', label: 'Uniglobe' },
    { value: 'Virtuoso', label: 'Virtuoso' },
    { value: 'WESTA', label: 'WESTA' },
    { value: 'NONE', label: 'NONE' },
    { value: 'Other', label: 'Other' },
];

export default affiliations;

